module.exports = __webpack_public_path__ + "img/Music_story_end.3ff47d79.png";